import { CookiesHelpers } from "../helpers/cookie-helpers";
import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class LoginPopupComponent implements IComponent {
    public id = '';

    private element: HTMLElement;

    private watchLoginCallbacks: Array<Function> = [];

    private usernameElement: HTMLInputElement | null = null;
    private passwordElement: HTMLInputElement | null = null;
    private rememberMeCheckboxElement: HTMLInputElement | null = null;

    private username = '';
    private password = '';

    private usernameId = 'inOne';
    private passwordId = 'inTwo';
    private rememberId = 'inThree';

    private crendentialsCookieKey = 'TIUSER'

    constructor(element: HTMLElement) {
        this.element = element;
    }

    public hide() {
        this.element.addClass('hidden');

        this.element.innerHTML = '';
    }

    public show() {
        const html = this.getHTML();
        this.element.innerHTML = html;

        setTimeout(() => {
            this.usernameElement = this.element.findFirst('#' + this.usernameId) as HTMLInputElement;
            this.passwordElement = this.element.findFirst('#' + this.passwordId) as HTMLInputElement;
            this.rememberMeCheckboxElement = this.element.findFirst('#' + this.rememberId) as HTMLInputElement;
            this.init();

            this.onLoginClick();
            this.element.removeClass('hidden');
        }, 150);
    }

    public subscribeLogin(fx: Function) {
        this.watchLoginCallbacks.push(fx);
    }

    public onLoginClicked() {
        for (const callback of this.watchLoginCallbacks) {
            callback(this.username, this.password);
        }
    }

    private init() {
        const preValues = CookiesHelpers.getCookie(this.crendentialsCookieKey);
        try {
            if (preValues) {
                const credentials = JSON.parse(preValues);
                if (credentials && credentials.username && credentials.password) {
                    this.username = credentials.username;
                    this.password = credentials.password;

                    this.rememberMeCheckboxElement && (this.rememberMeCheckboxElement.checked = true);
                    this.usernameElement && (this.usernameElement.value = this.username);
                    this.passwordElement && (this.passwordElement.value = this.password);
                }
            }
        } catch {}
    }

    private onLoginClick() {
        this.element.findFirst('button')?.ifExistThen((el: HTMLElement) => {
            if (el.classList.contains('inited')) {
                return;
            }

            el.classList.add('inited');
            el.addEventListener('click', () => {
                this.username = this.usernameElement?.value ?? '';
                this.password = this.passwordElement?.value ?? '';
                if (this.rememberMeCheckboxElement && this.rememberMeCheckboxElement.checked) {
                    const storeToCookieValue = JSON.stringify({username: this.username, password: this.password});
                    CookiesHelpers.setCookie(this.crendentialsCookieKey, storeToCookieValue, 365);
                } else {
                    CookiesHelpers.setCookie(this.crendentialsCookieKey, '', -1);
                }
    
                this.hide();
                this.onLoginClicked();
            });
        })
    }

    private getHTML(): string {
        return `<h2 class="highcharts-popup-main-title">Login</h2>
        <div class="highcharts-popup-lhs-col highcharts-popup-lhs-full">
            <label for="highcharts-annotation-format">Username</label>
            <input name="highcharts-annotation-format" type="text" id="${this.usernameId}" autocomplete="off" value=""
                class="highcharts-popup-field">
        </div>
        <div class="highcharts-popup-lhs-col highcharts-popup-lhs-full">
            <label for="highcharts-annotation-format">Password</label>
            <input name="highcharts-annotation-format" style="-webkit-text-security: disc !important; font-family: text-security-disc;" type="text" id="${this.passwordId}" autocomplete="off" value=""
                class="highcharts-popup-field">
        </div>
        <div class="highcharts-popup-lhs-col highcharts-popup-lhs-full checkbox">
            <input name="highcharts-annotation-format" type="checkbox" id="${this.rememberId}" value=""
                class="highcharts-popup-field">
            <label for="remember">Remember Me?</label>
        </div>
        <div class="highcharts-popup-bottom-row">
            <button>Login</button>
        </div>`;
    }
}